const config = {
  requiredVersion: 140, //11
};

export default config;
